import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ItemHandlingRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("ItemHandling");
